import SupportSearch from "@components/pages/Support/SupportSearch";
import React from "react";

const InputSearchHelp = () => {
  return <SupportSearch />;
};

export default InputSearchHelp;
